<template>
  <FlickityCarousel class="deal-carousel deal-carousel--active">
    <div
      v-for="(carouselItem, index) in carouselImages"
      :key="index"
      class="carousel-cell"
    >
      <div class="story-image-container">
        <img
          class="story-image"
          :src="carouselItem.image"
          :alt="getAltText(carouselItem)"
        >
        <!-- Descriptions temporarily removed; but the data remains -->
        <!-- <div class="description-container">
          <span :class="{ 'overflow-ellipsis' : !descriptionExpanded }">
            {{ carouselItem.description }}
          </span>
          <span
            v-if="carouselItem.description"
            class="expand-text-icon"
            @click="expandHideText"
          >
            <img
              v-if="descriptionExpanded"
              :src="UpChevron"
            >
            <img
              v-else
              :src="DownChevron"
            >
          </span>
        </div> -->
      </div>
    </div>
  </FlickityCarousel>
</template>

<script>
import FlickityCarousel from '../../../../../nuxt/components/FlickityCarousel.vue';
import DownChevron from '../../../../public/down-chevron.svg';
import UpChevron from '../../../../public/up-chevron.svg';
import MarketplaceRibbon from '../../../../public/marketplace-ribbon.svg';

export default {
  components: {
    FlickityCarousel,
  },
  props: {
    storyImages: {
      type: Array,
      default: () => [],
    },
    coverImage: {
      type: String,
      default: '',
    },
    coverImageCaption: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      descriptionExpanded: false,
      carouselImages: [],
      // TODO: This should be grabbed from the deal object once added
      marketPlaceDeal: true,
      DownChevron,
      UpChevron,
      MarketplaceRibbon,
    };
  },
  created() {
    const coverImageObject = {
      image: this.coverImage,
      description: this.coverImageCaption,
    };
    this.carouselImages.push(coverImageObject);
    this.carouselImages.push(...this.storyImages);
  },
  methods: {
    getAltText(carouselItem) {
      return carouselItem.alt_text || carouselItem.description || carouselItem.image || '';
    },
    // Descriptions temporarily removed; but the data remains
    // expandHideText() {
    //   this.descriptionExpanded = !this.descriptionExpanded;
    // },
  },
};
</script>

<style scoped>
.story-image {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    object-fit: contain;
}
.deal-carousel {
    width: 100%;
}
.carousel-cell {
    width: 100%;
    height: 475px;
    background: #343D45;
}
.story-image-container {
    height: 100%;
    width: 100%;
    position: relative;
    padding-bottom: 56.25%;
}
.expand-text-icon {
    padding: 0 10px;
    display: none;
    cursor: pointer;
}
.ribbon {
    position: absolute;
    margin: -10px;
}
@media (max-width: 768px) {
  .carousel-cell {
    height: 430px;
  }
}
@media (max-width: 576px) {
  .carousel-cell {
    height: 275px;
  }
}
</style>

<style>
/* TODO: Refactor carousel styles so all carousels use the same css */
/* Flickity does not respond well to 'scoped' styles so they have to be done seperately */
/* However if we just modified the existing flickity CSS file or the one it points to,
then the base styles for buttons and arrows would be the same everywhere it is used */
.flickity-prev-next-button .arrow {
    fill:#0275D8;
}
.flickity-prev-next-button:hover,
.flickity-prev-next-button:active {
  box-shadow: 0px 0px 10px rgba(2, 117, 216, 0.3);
  opacity: 1;
}

.flickity-page-dots .dot {
  background: rgba(2, 117, 216, 0.25);
  border-radius: 3px;
  width: 25px;
  height: 10px;
  opacity: 1;
  margin: 10px;
}
.flickity-page-dots .dot.is-selected {
  background: #0275D8;
}
.flickity-page-dots {
  position: static;
  margin: 15px 0;
}

@media (max-width: 600px) {
    .flickity-prev-next-button {
        width: 20px;
        height: 20px;
    }
}
</style>
